/**
 * useQboOverlay
 *
 * Fetches /api/quickbooks/executive-overlay once per Dashboard mount.
 * Returns { overlay, isLive, loading, error, refresh }.
 *
 * `isLive` is true when the tenant has a real QuickBooks connection and the
 * cached snapshot's P&L is available. When false, dashboards fall back to the
 * existing HubSpot-derived demo values without any UI churn.
 */
import { useCallback, useEffect, useState } from "react";
import api from "../utils/api";

export function useQboOverlay() {
  const [overlay, setOverlay] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get("/quickbooks/executive-overlay");
      setOverlay(res.data);
    } catch (err) {
      setError(err?.response?.data?.detail || err?.message || "failed");
      setOverlay(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const isLive = !!(overlay && overlay.available && overlay.source === "quickbooks");
  return { overlay, isLive, loading, error, refresh: load };
}
